import { Box, Button, Stack, TextField, Typography, Autocomplete, ListItem, ListItemText, Tooltip, IconButton, Paper, Divider } from '@mui/material';
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import '../../../FrontOffice/IPPatients/PatientsDetails/ClinicalNotes/DoctorNotes.css'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { Colors } from '../../../../Styles/Colors';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import { debounce } from '../../../../Components/CommonFunctions/CommonFunctions';
import {  grey } from '@mui/material/colors';
import VoiceToText from '../../../../Components/Common Components/VoiceToText';
import  MicIcon from '@mui/icons-material/Mic';
import DeleteIcon from '@mui/icons-material/Delete';
import { TemplatePopup } from '../SarasOtherDocNotes/SarasCommonComp';
import { DeletePopup } from '../../../../Components/Common Components/CommonComponents';


const TemplateActionButton = ({ label, onClick }) => (
    <Button
        color="primary"
        fullWidth
        sx={{ justifyContent: 'flex-start', pl: 2, textTransform: 'capitalize' }}
        onMouseDown={(e) => {
            e.preventDefault();
            onClick();
        }}
    >
        {label}
    </Button>
);


class DocNewLayoutRight extends Component {
    constructor(props) {
        super(props)
        this.state = {
            comments: this.props.layoutDetail?.comments || "",
            commentSuggest: [],
            isDisable: false,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: '',
            listenPopUp : false,
            templateList: [],
            selectedTemplateName: null,
            openPopupAddNew: false,
            templateName: '',
            deleteTemplateName: {},
            tempType: '',
            deletePopup: false,
            templateLoad: false,
            removeData: false,
        }
        this.getSuggestionApi = debounce(this.getNewLayoutSuggestion, 500)
    }

    componentDidMount() {
        if (this.props.EditNewLayoutText) {
            this.updateState();
        }
        this.getTemplateData();
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.EditNewLayoutText !== this.props.EditNewLayoutText) && this.props.EditNewLayoutText) {
            this.updateState();
        }
    }

    updateState = () => {
        if (this.props.EditNewLayoutText) {
            this.setState({
                comments: this.props.EditNewLayoutText || "",
            }, () => { this.props.ClearPropsData(this.props.stateKey) })
        }
    }

    getNewLayoutSuggestion = (search = '') => {
        try {
            RestAPIService.getAllTwo(Serviceurls.DOC_NEW_LAYOUT_SUGG_GET +
                `?system_name=${this.props.layoutDetail?.label}&search_key=${search}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        if (this.state.comments) {
                            this.setState({
                                commentSuggest: response.data.data ? response.data.data : []
                            })
                        }
                    }
                    else {
                        this.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    this.errorMessage(error.message)
                })
        }
        catch (e) {
            this.errorMessage(e.message)
        }
    }

    ClearData = () => {
        this.setState({
            comments: "",
        })
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }
    listenPopUp = () => {
        this.setState({
            listenPopUp: false
        })
    }

    deleteTemplateData = () => {
            try {
                this.setState({ removeData: true });
                let apiUrl = Serviceurls["SARAS_DOC_NEW_LAYOUT_TEMP_GET"];
                apiUrl += `?system_name=${this.props.layoutDetail?.label}&id=${this.state.deleteTemplateName?.id}`
                RestAPIService.delete(apiUrl)
                    .then(response => {
                        if (response.data.status === "success") {
                            this.successMessage(response.data.message);
                            this.setState({
                                openPopupAddNew: false,
                                templateLoad: false,
                                deleteTemplateName: {},
                                selectedTemplateName: '',
                                deletePopup: false,
                                removeData: false,
                                isEdit: false
                            });
                            this.getTemplateData();
                        }
                    })
                    .catch(e => {
                        this.setState({ removeData: false });
                        this.errorMessage(e.response.data.message || e.message)
                    });
            } catch (e) {
                this.setState({ removeData: false });
                this.errorMessage(e.message);
            }
        }

    voiceToTextgetter = (textStorage) => {
        if (textStorage != '') {
            this.setState({
                comments: this.state.comments + " " + textStorage,
                listenPopUp: false
            })
        }
    }

    PostNewLayoutComments = () => {
        try {
            const { SelectedCompCustomName, layoutDetail, PatientData } = this.props;
            const label = (SelectedCompCustomName || layoutDetail?.custom_name);
            if ((this.state.comments) !== "") {
                let data = {
                    "appointment_id": PatientData?.appointment_id,
                    "patient_id": PatientData?.patient_id,
                    "system_name": layoutDetail?.label,
                    "custom_name": layoutDetail?.custom_name,
                    "comments": this.state.comments
                }

                RestAPIService.create(data, Serviceurls.DOC_NEW_LAYOUT_GET)
                    .then((response) => {
                        if (response.data.status === "success") {
                            this.successMessage(response.data.message)
                            this.ClearData()
                            this.props.CallgetApi(Date.now())
                        } else {
                            this.errorMessage(response.data.message)
                        }
                    }).catch(error => {
                        this.errorMessage(error.response.data.message || error.message)
                    })
            } else {
                this.errorMessage(`Enter ${label}`)
            }
        } catch (error) {
            this.errorMessage(error.message)
        } finally {
            this.setState({ isDisable: false })
        }
    }

    

    renderSrchTemp = () => {
            return (<Autocomplete
                clearIcon
                size="small"
                sx={{ width: '20vw', marginTop: "0.5vw", marginRight: "1vw" }}
                options={this.state.templateList}
                value={this.state.selectedTemplateName}
                getOptionLabel={(option) => typeof option === 'string' ? option : option?.template_name}
                onChange={(e, value) => {
                    this.setState({
                        selectedTemplateName: value,
                        comments: value.comments ? ((this.state.comments || '') + value.comments).slice(0, 5000) : this.state.comments
                    }, ()=>{
                        this.setState({
                            selectedTemplateName : null
                        })
                    })
                }}
                renderOption={(props, option) => (
                    <li {...props} style={{ padding: '0vh 1.5vh' }}>
                        <ListItem sx={{ display: 'flex', justifyContent: 'space-between', p: 0, m: 0 }}>
                            <ListItemText
                                primary={
                                    option?.template_name?.length > 30 ? (
                                        <Tooltip title={option.template_name} placement="top">
                                            <div>{option.template_name.slice(0, 21) + '...'}</div>
                                        </Tooltip>
                                    ) : (
                                        option.template_name
                                    )
                                }
                            />
                            <Tooltip title="Delete Template" placement="top" arrow>
                                <IconButton
                                    edge="end"
                                    color="error"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        this.setState({
                                            tempType: 'delete',
                                            deleteTemplateName: option,
                                            deletePopup: true,
                                        })
                                    }}
                                >
                                    <DeleteIcon sx={{ height: '2.5vh', width: '2.5vw' }} />
                                </IconButton>
                            </Tooltip>
                        </ListItem>
                    </li>
                )}
                renderInput={(params) => <TextField {...params} label="Select Template Name" />}
                PaperComponent={({ children }) => (
                    <Paper sx={{ maxHeight: '25vw', overflow: 'auto' }}>
                        {children}
                        <Divider />
                        <TemplateActionButton
                            label="Save As Template"
                            onClick={() => this.setState({ openPopupAddNew: true, templateLoad: false, tempType: 'Add' })}
                        />
                        {this.state.selectedTemplateName && (
                            <TemplateActionButton
                                label="Edit Template"
                                onClick={() =>
                                    this.setState({
                                        openPopupAddNew: true,
                                        templateLoad: false,
                                        tempType: 'rename',
                                        templateName: this.state.selectedTemplateName.template_name,
                                    })
                                }
                            />
                        )}
                    </Paper>
                )}
            />)
        }

        getTemplateData = () => {
                let apiUrl = Serviceurls["SARAS_DOC_NEW_LAYOUT_TEMP_GET"];
                apiUrl += `?system_name=${encodeURIComponent(this.props.layoutDetail?.label)}`
                try {
                    RestAPIService.getAll(apiUrl)
                        .then((response) => {
                            if (response.data.status === 'success') {
                                this.setState({ templateList: response.data.data })
                            }
                        }).catch((error) => {
                            this.errorMessage(error?.response?.data?.message || error.message)
                        })
                } catch (error) {
                    this.errorMessage(error.message)
                }
            }
            
        postNewTemplateData = () => {
                try {
                    this.setState({ templateLoad: true })
                    const data = {
                        "id": this.state.tempType === 'rename' ? this.state.selectedTemplateName?.id : null,
                        "template_name": CommonValidation.removeSpace(this.state.templateName),
                        "comments": CommonValidation.removeSpace(this.state.comments),
                        "system_name" : this.props.layoutDetail?.label || "",
                        "custom_name" : this.props?.layoutDetail?.custom_name
                    }
                    if (!CommonValidation.removeSpace(this.state.templateName)) {
                        this.errorMessage("Please enter template name")
                        this.setState({ templateLoad: false })
                    } else if (!CommonValidation.removeSpace(this.state.comments)) {
                        this.errorMessage(`Please enter ${this.props?.layoutDetail?.custom_name}`)
                    } else {
                        RestAPIService.create(data, Serviceurls["SARAS_DOC_NEW_LAYOUT_TEMP_GET"])
                            .then((response) => {
                                if (response?.data?.status === 'success') {
                                    this.successMessage(response.data.message)
                                    this.setState({
                                        templateLoad: false,
                                        openPopupAddNew: false,
                                        templateName: '',
                                        selectedTemplateName: '',
                                        isEdit: false
                                    })
                                    this.getTemplateData()
                                }
                            }).catch((error) => {
                                this.setState({ templateLoad: false })
                                this.errorMessage(error?.response?.data?.message || error.message)
                            })
                    }
                } catch (error) {
                    this.setState({ templateLoad: false })
                    this.errorMessage(error.message)
                }
            }

    render() {
        const { t, SelectedCompCustomName, layoutDetail } = this.props;
        const label = (SelectedCompCustomName || layoutDetail?.custom_name);
        return (
            <Box>
                <Box height={"61.3vh"}>
                    <Box className='eMed_refdoc_title' sx={{display: "flex", justifyContent :"space-between"}}>
                        <Typography >{label}</Typography>
                        <MicIcon sx={{ color: grey[1000], cursor: "pointer", marginRight: "1.1vw" }} onClick={() => { this.setState({ listenPopUp: true }) }}></MicIcon >
                    </Box>
                    <Box sx={{ display:'flex', justifyContent:'flex-end'}}>
                        {this.renderSrchTemp()}
                    </Box>
                    <Autocomplete
                        size='small'
                        clearIcon
                        freeSolo
                        autoSelect={false}
                        sx={{ margin: '1vw' }}
                        options={this.state.commentSuggest || []}
                        getOptionLabel={option => option}
                        value={this.state.comments || ''}
                        onChange={(e, value) => {
                            this.setState({
                                comments: value,
                            })
                        }}
                        renderInput={(params) => <TextField {...params}
                            inputProps={{ ...params.inputProps, maxLength: 5000 }}
                            multiline
                            rows={14}
                            sx={{
                                "& .MuiInputBase-root": {
                                    paddingRight: "0px  !important",
                                },
                                "& .MuiOutlinedInput-inputMultiline": {
                                    paddingRight: "0px  !important",
                                },
                            }}
                            onChange={(e) => {
                                this.setState({ comments: e.target.value || '' }, () => {
                                    if (e.target.value) {
                                        this.getSuggestionApi(e.target.value)
                                    } else {
                                        this.setState({ commentSuggest: [] })
                                    }
                                })
                            }}
                            label={label}
                            placeholder={`${label} (Max 5000 Characters)`}
                            helperText={`( ${5000 - (this.state.comments?.length || 0)} / 5000 )`}
                        />}
                    />
                </Box>
                <Stack spacing={2} direction="row" sx={{ backgroundColor: Colors.DataTblHeaderbg }} alignItems="center" justifyContent="center" height={"6vh"}>
                    <Button variant='outlined' size="small" id="eMed_Config_btn" onClick={this.ClearData}>{t("Clear")}</Button>
                    <Button variant='contained' size="small" disabled={this.state.comments === "" || this.state.isDisable}
                        id="eMed_Config_btn" onClick={() => {
                            this.setState({ isDisable: true }, this.PostNewLayoutComments);
                        }}>
                        {t("Add")}
                    </Button>
                </Stack>
                {this.state.isErrorMsg &&
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />}
                {this.state.successMsg &&
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />}
                {this.state.listenPopUp ?
                    <VoiceToText
                        voiceTextConverter={this.voiceToTextgetter.bind(this)}
                        listenPopUp={this.listenPopUp.bind(this)}
                    /> : null
                }
                {this.state.deletePopup && <DeletePopup
                                    DeletTitle={`Are you sure? Do you want to delete ${this.state.deleteTemplateName?.template_name} ?`}
                                    deleteAlertPopupClose={() => { this.setState({ deletePopup: false, isDeleteCliked: false }) }}
                                    removeData={this.deleteTemplateData.bind(this)}
                                    disable={this.state.removeData}
                                />}
                {this.state.openPopupAddNew && <TemplatePopup
                    open={this.state.openPopupAddNew}
                    Title={this.props?.layoutDetail?.custom_name}
                    onClose={() => this.setState({ openPopupAddNew: false, templateLoad: false, templateName: "" })}
                    templateName={this.state.templateName || ''}
                    setTemplateName={(value) => this.setState({ templateName: value })}
                    tempType={this.state.tempType}
                    onSubmit={this.postNewTemplateData.bind(this)}
                    loading={this.state.templateLoad}
                />}
            </Box>
        )
    }
}
export default withTranslation()(DocNewLayoutRight)